import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from '../../../utils/logger';

/**
 * OAuth callback loading screen.
 * AuthContext handles actual authentication - this is just a visual indicator.
 */
function AuthCallback() {
  const [status, setStatus] = useState('处理登录中...');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const hasCode = new URLSearchParams(window.location.search).has('code')
    || new URLSearchParams(window.location.hash.slice(1)).has('code');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const code = urlParams.get('code') || hashParams.get('code');
    const accessToken = urlParams.get('access_token') || hashParams.get('access_token');
    const authError = urlParams.get('error') || hashParams.get('error');

    if (authError) {
      logger.error('Auth error in URL:', authError);
      setError(`Authentication failed: ${authError}`);
      setStatus('登录失败');
      setTimeout(() => navigate('/', { replace: true }), 3000);
      return;
    }

    if (code || accessToken) {
      // Navigate to the target page IMMEDIATELY — don't wait for auth to complete.
      // AuthContext processes the auth code in the background (captured during render).
      // The target page renders its shell while auth completes.
      const redirectUrl = localStorage.getItem('auth_redirect_url') || '/';
      localStorage.removeItem('auth_redirect_url');
      navigate(redirectUrl, { replace: true });
      return;
    }

    setStatus('未检测到登录信息，正在重定向...');
    setTimeout(() => navigate('/', { replace: true }), 2000);
  }, [navigate]);

  // When we have a code, render nothing — we navigate away in the effect.
  // This prevents the 🔐 lock screen from flashing for one frame.
  if (hasCode && !error) return null;

  // Only show the lock screen for error or no-code cases
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '2rem',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <div style={{
          fontSize: '2rem',
          marginBottom: '1rem'
        }}>
          🔐
        </div>
        <h2 style={{
          margin: '0 0 1rem 0',
          color: '#333'
        }}>
          身份验证
        </h2>
        <p style={{
          margin: '0',
          color: error ? '#dc3545' : '#666'
        }}>
          {status}
        </p>
        {error && (
          <div style={{
            marginTop: '1rem',
            padding: '0.75rem',
            background: '#f8d7da',
            borderRadius: '4px',
            fontSize: '0.875rem',
            color: '#721c24'
          }}>
            {error}
          </div>
        )}
        {!error && (
          <div style={{
            marginTop: '1.5rem',
            padding: '0.5rem',
            background: '#f8f9fa',
            borderRadius: '4px',
            fontSize: '0.875rem',
            color: '#666'
          }}>
            请稍候，正在处理您的登录信息...
          </div>
        )}
      </div>
    </div>
  );
}

export default AuthCallback;
